import { IPromise } from 'angular'
import * as _ from 'lodash'
import * as Models from '../Models'
import * as AuthApiClient from './AuthApiClient'

export interface IAuthService {
  logout: () => void;
  login: (username: string, password: string, callback?: IAuthCallback) => void;
  checkLogin: (callback?: IAuthCallback) => void;
  loggedIn: () => boolean;
  getUsername: () => string;
  hasRole: (role: string) => boolean;
}

interface IAuthModel {
  authenticated: Boolean;
  email: string;
  roles: Array<string>;
  isLockedOut: boolean;
  isApproved: boolean;
}

class AuthModel implements IAuthModel {
  authenticated: Boolean;
  email: string;
  roles: Array<string>;
  isLockedOut: boolean;
  isApproved: boolean;
}

export interface IAuthCallback {
  (authSuccessful: boolean): void;
}

export class AuthService implements IAuthService {
  private authModel: AuthModel;

  public static $inject = ["AuthApiClient"];
  constructor(private authApiClient: AuthApiClient.IAuthApiClient) {
    this.authModel = new AuthModel();
  }

  public getUsername = (): string => {
    return this.authModel.email;
  };

  public loggedIn = (): boolean => {
    if (this.authModel.authenticated) {
      return true;
    }
    return false;
  };

  public hasRole = (role: string): boolean => {
    if (!!this.authModel.roles && _.indexOf(this.authModel.roles, role) > -1) {
      return true;
    }
    return false;
  };

  public logout = (): IPromise<any> => {
    this.authModel = new AuthModel();
    return this.authApiClient.getLogout();
  };

  public checkLogin = (callback?: IAuthCallback): void => {
    this.authApiClient.getUser().then((response: Models.Auth.GetUserResponse.GetUserResponse) => {
      if (response.successful) {
        this.authModel = <IAuthModel>{
          email: response.user.emailAddress,
          roles: response.user.roles.map((role) => {
            return role.name;
          }),
          authenticated: true,
          isApproved: response.user.isApproved,
          isLockedOut: response.user.isLocked,
        };
      } else {
        this.authModel = new AuthModel();
      }
      if (!!callback) {
        callback(response.successful);
      }
    });
  };

  public login = (username: string, password: string, callback?: IAuthCallback) => {
    this.authApiClient
      .postLogin(<Models.Auth.LoginRequest.LoginRequest>{ email: username, password: password, rememberMe: true })
      .then((response: Models.Auth.LoginResponse.LoginResponse) => {
        if (response.successful) {
          this.authModel = <IAuthModel>{
            email: response.user.emailAddress,
            roles: response.user.roles.map((role) => {
              return role.name;
            }),
            authenticated: true,
            isApproved: response.user.isApproved,
            isLockedOut: response.user.isLocked,
          };
        } else {
          this.authModel = new AuthModel();
        }
        if (!!callback) {
          callback(response.successful);
        }
      });
  };
}
